const StartAgain = () => {
    const handleClick = () => {
        window.location.reload()
    }

    return (
        <div className="text-[14px] underline underline-offset-2 cursor-pointer" onClick={handleClick}>
            RESET CHAT
        </div>
    )
}

export default StartAgain
